import { CommendaAiReferenceType } from '@commenda/api/commenda-ai/types';
import { MarkdownLinkHelper } from './MarkdownLinkHelper';

export interface ChatReference {
  type: CommendaAiReferenceType;
  referenceId: string;
}

const CORPORATION_SEGMENT = 'corporation';
const KEY_PERSONS_SEGMENT = 'key-persons';
const SERVICE_REQUEST_SEGMENT = 'service-request';

export class ChatReferenceHelper {
  static classify(href: string): ChatReference | null {
    if (!MarkdownLinkHelper.isFirstParty(href)) return null;

    const segments = MarkdownLinkHelper.getPathname(href)
      .split('/')
      .filter(Boolean);
    const [root, secondSegment, thirdSegment, fourthSegment] = segments;

    if (root === SERVICE_REQUEST_SEGMENT && segments.length === 2)
      return {
        type: CommendaAiReferenceType.SERVICE,
        referenceId: secondSegment,
      };

    if (root !== CORPORATION_SEGMENT) return null;

    if (segments.length === 2)
      return {
        type: CommendaAiReferenceType.ENTITY,
        referenceId: secondSegment,
      };

    if (segments.length === 4 && thirdSegment === KEY_PERSONS_SEGMENT)
      return {
        type: CommendaAiReferenceType.KEY_PERSON,
        referenceId: fourthSegment,
      };

    return null;
  }
}
